import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { LinearProgress, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import axios from "axios";
import api from "../common/api";

const normalizeList = payload => {
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.data)) return payload.data;
  return [];
};

const InvoicingSchedules = () => {
  const [billingPeriods, setBillingPeriods] = useState([]);
  const [invoicingSchedules, setInvoicingSchedules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0.25rem",
            fontSize: "0.8rem",
            maxWidth: "12rem"
          }
        }
      }
    });

  const textLabels = {
    toolbar: {
      search: "Buscar",
      viewColumns: "Ver columnas",
      filterTable: "Filtros",
      downloadCsv: "Exportar a CSV"
    },
    body: {
      noMatch: "No hay datos disponibles"
    },
    pagination: {
      next: "Siguiente",
      previous: "Anterior",
      rowsPerPage: "Filas por página:",
      displayRows: "de"
    },
    filter: {
      all: "Todos",
      title: "Filtros",
      reset: "Limpiar"
    }
  };

  const baseOptions = {
    selectableRows: false,
    responsive: "standard",
    rowsPerPage: 25,
    rowsPerPageOptions: [10, 25, 50, 100],
    download: true,
    print: false,
    textLabels
  };

  const scheduleTableOptions = {
    ...baseOptions,
    customToolbar: () => (
      <Tooltip title="Nueva programación">
        <IconButton
          onClick={() => {
            window.location.href = "/invoicing-schedule/new";
          }}
        >
          <AddIcon />
        </IconButton>
      </Tooltip>
    )
  };

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    const headers = { Authorization: `Bearer ${token}` };

    const load = async () => {
      setIsLoading(true);
      try {
        const { data } = await axios.get(api.invoicing_schedules, { headers });
        setBillingPeriods(normalizeList(data.billing_periods));
        setInvoicingSchedules(normalizeList(data.invoicing_schedules));
      } catch (err) {
        console.error(err);
        setBillingPeriods([]);
        setInvoicingSchedules([]);
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, []);

  const billingColumns = [
    {
      name: "name",
      label: "Nombre",
      options: { filter: true, filterType: "textField", sort: true }
    },
    {
      name: "start_date",
      label: "Fecha inicio",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "end_date",
      label: "Fecha fin",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    }
  ];

  const scheduleColumns = [
    {
      name: "name",
      label: "Nombre",
      options: { filter: true, filterType: "textField", sort: true }
    },
    {
      name: "description",
      label: "Descripción",
      options: {
        filter: true,
        filterType: "textField",
        sort: false,
        customBodyRender: value => {
          const s = value != null ? String(value) : "";
          return (
            <span title={s} style={{ wordBreak: "break-word" }}>
              {s}
            </span>
          );
        }
      }
    },
    {
      name: "result",
      label: "Resultado",
      options: {
        filter: true,
        filterType: "textField",
        sort: false,
        customBodyRender: value => {
          const s = value != null ? String(value) : "";
          return (
            <span title={s} style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
              {s}
            </span>
          );
        }
      }
    },
    {
      name: "scheduled_date",
      label: "Programado",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "finished_date",
      label: "Finalizado",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    }
  ];

  if (isLoading) {
    return (
      <div>
        <Typography variant="h6">Cargando...</Typography>
        <LinearProgress />
      </div>
    );
  }

  return (
    <MuiThemeProvider theme={getMuiTheme()}>
      <MUIDataTable
        title="Periodos de facturación"
        data={billingPeriods}
        columns={billingColumns}
        options={baseOptions}
      />
      <div style={{ marginTop: "2rem" }} />
      <MUIDataTable
        title="Programaciones de facturación"
        data={invoicingSchedules}
        columns={scheduleColumns}
        options={scheduleTableOptions}
      />
    </MuiThemeProvider>
  );
};

export default InvoicingSchedules;
